import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gvacf54e28: FaireBrandEntity = {
  token: "b_gvacf54e28",
  type: "brand",
  name: "Wynn's Kitchen",
  avatarUrl:
    "https://cdn.faire.com/fastly/8ed903971b21bc040be000fae7f399078ab0e8901c95fcdc20bd1a0aabea9a3a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d7c19b15f787e693d01522b47d7f522e38a4c8177d942a075a9d8cfdedafc1f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8ed903971b21bc040be000fae7f399078ab0e8901c95fcdc20bd1a0aabea9a3a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7c19b15f787e693d01522b47d7f522e38a4c8177d942a075a9d8cfdedafc1f0.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Asian flavors aren’t just a taste, they’re more like an escape. They dance across the palate, transport us far away from everyday go-to’s, and inspire a triumphant fork-drop moment. But all too often, the Asian flavors we love come with hidden surprises: Added sugar, salt, artificial ingredients, and preservatives, to name a few.\n\nAt Wynn’s Kitchen, we embarked on a mission to rethink the Asian food aisle. We asked ourselves, “Do these remarkable Asian flavor sensations have to come loaded with unhealthy stuff?” “Hell no, they don’t!” we decided. So our ace home chef and company founder, Wynn Austin, concocted batches of Asian condiments with simple, all-natural ingredients that captured the tastes she loved growing up. And she wouldn’t let anything artificial or harmful near her creations, so you could enjoy them on repeat and feel good.\n\nWYNN’S KITCHEN. WE’RE RETHINKING THE ASIAN FOOD AISLE.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.088Z",
    importedBy: "entity-db-cli",
  },
};
